import { ReactNode } from "react";
import { TriangleAlert } from "lucide-react";
import cn from "classnames";
import styles from "./styles.module.scss";

type Invalid = boolean | string | { message?: string } | undefined | null;

interface Props {
  legendText?: ReactNode;
  invalid?: Invalid;
  invalidText?: ReactNode;
  // Accepted for API compatibility with the previous WFP-UI-based FormGroup; unused.
  startDate?: Date;
  className?: string;
  children?: ReactNode;
}

// Form group that shows a label on top and an error below. Rebuilt on Tailwind
// (was the WFP-UI FormGroup + Icon + warning glyph). legendText may be a node
// (e.g. a label span + a FormHint tooltip), so it's rendered as-is inline.
const FormGroup = ({ legendText, invalid, invalidText, className, children }: Props) => {
  const message =
    typeof invalid === "object" && invalid?.message
      ? invalid.message
      : typeof invalid === "string"
      ? invalid
      : invalidText
      ? invalidText
      : "required";

  return (
    <div className={cn(styles.customFormGroup, className)}>
      {legendText !== undefined && legendText !== "" && (
        <div className="mb-1.5 flex items-center gap-1 text-sm font-semibold">{legendText}</div>
      )}
      {children}
      {!!invalid && (
        <div className="mt-2 flex items-center gap-1 text-xs font-bold [color:var(--support-01)]">
          <TriangleAlert className="size-3.5 shrink-0" />
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};

export default FormGroup;
